import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerRoutingModule } from './container-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ContainerListComponent } from './container-list/container-list.component';
import { ContainerFormComponent } from './container-form/container-form.component';

@NgModule({
  declarations: [
    ContainerListComponent,
    ContainerFormComponent
  ],
  imports: [
    CommonModule,
    ContainerRoutingModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    SharedModule,
    FormsModule
  ]
})
export class ContainerModule { }
